import type { AppIcon } from "@/components/appIcons";
import { cn } from "@/lib/utils";

interface MultiFilterSelectTriggerLabelsProps {
  icon: AppIcon;
  showTriggerIcon: boolean;
  selectedLabel: string | null;
  placeholder: string;
  isFullWidth: boolean;
  countLabel: string;
}

export function MultiFilterSelectTriggerLabels({
  icon,
  showTriggerIcon,
  selectedLabel,
  placeholder,
  isFullWidth,
  countLabel,
}: MultiFilterSelectTriggerLabelsProps) {
  const Icon = icon;

  return (
    <span
      className={cn(
        "flex min-w-0 flex-1 gap-2",
        isFullWidth ? "flex-col items-start" : "items-center",
      )}
    >
      {showTriggerIcon ? <Icon className="text-[18px] text-muted-foreground shrink-0" /> : null}
      <span
        className={cn(
          "truncate text-left",
          isFullWidth ? "min-w-0 max-w-full text-[13px] font-semibold" : "max-w-[140px]",
        )}
      >
        {selectedLabel ?? placeholder}
      </span>
      {isFullWidth ? (
        <span className="text-[11px] font-medium tabular-nums text-muted-foreground">
          {countLabel}
        </span>
      ) : null}
    </span>
  );
}
